define((require) => {
    "use strict";

    var ActionPropertiesView          = require("ui/experience/action/ActionPropertiesView"),
        ImprovedView                  = require("editor/zbone/ImprovedView"),
        SizeAndPositionPropertiesView = require("ui/experience/widgets/SizeAndPositionPropertiesView"),
        template                      = require("ui/experience/widgets/linkWidget/LinkWidgetPropertiesView.tpl");

    const EXPAND_PROPERTY = "actionExpanded";

    /**
     * The properties view for a link widget.
     *
     * @class LinkWidgetPropertiesView
     * @constructor
     *
     * @cfg {LinkWidgetModel} model The model for the link widget being edited.
     */
    return ImprovedView.extend("LinkWidgetPropertiesView", {
        expandProperty: EXPAND_PROPERTY,

        template: template,

        regions: {
            sizeAndPositionProperties: ".size-and-position-properties",
            actionProperties: ".action-properties",
            analyticsProperties: ".analytics-properties"
        },

        onRender: function() {
            this.__super();
            this.sizeAndPositionProperties.show(new SizeAndPositionPropertiesView({
                model: this.model,
                editorViewModel: this.viewScope.viewModel,
                widgetView: this.options.widgetView
            }));
            this.actionProperties.show(new ActionPropertiesView({model: this.model, showEffects: false}));
            this.analyticsProperties.show(this._setAnalyticsLabel({model: this.model}));
        }
    }, {
        EXPAND_PROPERTY
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/linkWidget/LinkWidgetPropertiesView.js